export default "__VITE_ASSET__BQXUrsfh__"